<div class="flex-container">
  <wr-building-section-select
    [building]="inspection().building"
    [selectedSection]="selectedSection$ | async"
    (selectedSectionChange)="selectedSection$.next($event)">
  </wr-building-section-select>

  @if (canEdit()) {
    <button nbButton
            status="basic"
            size="small"
            [disabled]="formWrapper().disabled()"
            (click)="importTemplate()">
      <nb-icon icon="download-outline" pack="eva"></nb-icon>
      Vorlage importieren
    </button>
  }
</div>

@if (selectedSection$.value) {
  <div class="split-view">
    <nb-card class="left">
      <nb-card-header>
        <wr-search-bar
          [search]="search$ | async"
          (searchChange)="search$.next($event)">
        </wr-search-bar>

        <button nbButton
                ghost
                [status]="(onlyMarkedForPostProcessing$ | async) ? 'warning' : 'basic'"
                nbTooltip="Nur für die Nachbearbeitung markierte Prüfpunktzeilen anzeigen"
                (click)="onlyMarkedForPostProcessing$.next(!onlyMarkedForPostProcessing$.value)">
          <nb-icon icon="bookmark" pack="eva"></nb-icon>
        </button>

        @if (canEdit()) {
          <button nbButton
                  ghost
                  status="primary"
                  nbTooltip="Prüfpunktzeile hinzufügen"
                  [disabled]="formWrapper().disabled()"
                  (click)="showAddInspectionEntryDialog()">
            <nb-icon icon="plus-outline" pack="eva"></nb-icon>
          </button>
        }

        @if (sectionContextMenu.items.length) {
          <button nbButton
                  ghost
                  nbTooltip="Weitere Aktionen"
                  [nbContextMenu]="sectionContextMenu.items"
                  [nbContextMenuTag]="sectionContextMenu.tag">
            <nb-icon icon="more-vertical-outline" pack="eva"></nb-icon>
          </button>
        } @else {
          <button nbButton ghost disabled>
            <nb-icon icon="more-vertical-outline" pack="eva"></nb-icon>
          </button>
        }
      </nb-card-header>

      <nb-card-body class="no-padding">
        @if (inspectionEntriesGrouped$ | async; as groups) {
          <wr-inspection-entry-group-list
            [groups]="groups"
            [disabled]="formWrapper().disabled()"
            [canEdit]="canEdit()"
            [selectedEntry]="selectedEntry$ | async"
            [loading]="entriesLoading()"
            (selectedEntry$)="selectedEntry$.next($event)"
            [(selectedGroupId)]="selectedGroupId"
            (deleteGroup)="deleteGroup($event)"
            (markPostProcessingDone)="markPostProcessingDone($event)">
          </wr-inspection-entry-group-list>
        }
      </nb-card-body>
    </nb-card>

    @if (selectedEntry$ | async; as selectedEntry) {
      <nb-card class="right">
        <nb-card-header>
          <span>{{ getCheckpointString(selectedEntry) }}</span>
          <div class="flex-grow"></div>

          @if (getEquipmentCount(selectedEntry); as count) {
            <div class="header-tga"
                 [nbTooltip]="count + ' ' + (count | pluralize:'TGA':'TGAs') + ' verknüpft'">
              <nb-icon icon="cube" pack="fas"></nb-icon>
              <span>{{ count }}</span>
            </div>
          } @else if (isTgaRelevant(selectedEntry)) {
            <div class="header-tga relevant"
                 nbTooltip="TGA relevanter Prüfpunkt">
              <nb-icon icon="cube" pack="fas"></nb-icon>
            </div>
          }

          @if (getInspectionEntryStatusFromFormGroup(selectedEntry); as status) {
            @if (getInspectionEntryStatusText(status); as statusText) {
              <nb-icon class="entry-status-icon"
                       icon="info-outline"
                       pack="eva"
                       [status]="status"
                       [nbTooltip]="statusText"></nb-icon>
            }
          }

          @if (inspectionContext.repairTasksVisible() && selectedEntry.value.id && inspectionContext.hasRepairTask(selectedEntry.value.id!)) {
            <button nbButton
                    ghost
                    status="info"
                    nbTooltip="Reparaturauftrag vorhanden"
                    (click)="editRepairTask(selectedEntry)">
              <nb-icon icon="screwdriver-wrench" pack="fas"></nb-icon>
            </button>
          }

          @if (entriesThatCanBeAppliedFromOtherSections$.value.length) {
            <button nbButton
                    class="glowing"
                    status="primary"
                    nbTooltip="Prüfpunkt übernehmen"
                    (click)="applyEntryFromOtherSection()">
              <nb-icon icon="download-outline" pack="eva"></nb-icon>
            </button>
          }

          <button nbButton
                  ghost
                  [nbContextMenu]="entryContextMenu.items"
                  [nbContextMenuTag]="entryContextMenu.tag"
                  nbTooltip="Ausblenden">
            <nb-icon icon="more-vertical" pack="eva"></nb-icon>
          </button>
        </nb-card-header>

        <nb-card-body>
          <wr-inspection-entry-form
            [formWrapper]="formWrapper()"
            [inspectionEntry]="selectedEntry">
          </wr-inspection-entry-form>
        </nb-card-body>
      </nb-card>
    }
  </div>
} @else {
  <div class="text-hint">Gebäudeteil auswählen, um Einträge anzuzeigen</div>
}
